import { FC, MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Stack } from '@bonusly/design-system';

import { Bonus } from '../../../../../types/bonus';
import { useSayThanks } from '../../hooks/use-say-thanks';
import { CommentComposer } from './comment-composer';
import { CommentsContainer } from './comments-container';

export interface CommentsProps {
	bonus: Bonus;
	feedFilter?: string;
	initalText?: string;
	isModalDisplay?: boolean;
	isOpen: boolean;
	onClose?: VoidFunction;
	onCommentSubmitFailure: (reason: string) => void;
	onOpen?: VoidFunction;
	commentBoxRef?: MutableRefObject<HTMLDivElement | null>;
}

export const Comments: FC<CommentsProps> = ({ bonus, feedFilter, isOpen, onClose, onOpen, isModalDisplay = false, commentBoxRef, ...rest }) => {
	const { t } = useTranslation('recognition');

	const hasComments = !!bonus.child_bonuses?.length;
	const hasFeedback = !!bonus.evaluations?.length;
	const displayComments = hasComments || hasFeedback;
	const sayThanks = useSayThanks(bonus);

	return (
		<Stack spacing={2}>
			{displayComments && (
				<CommentsContainer
					bonus={bonus}
					feedFilter={feedFilter}
					isModalDisplay={isModalDisplay}
					data-testid="comments-container"
					parentBonus={bonus}
					bg="bg.subtle"
				/>
			)}

			{hasComments && !isOpen && (
				<Button onClick={onOpen} backgroundColor="bg.subtle" colorScheme="secondary" variant="alpha">
					{sayThanks ? t('bonus_card.thanks_button') : t('comment.add_comment_button')}
				</Button>
			)}

			{isOpen && <CommentComposer bonus={bonus} onSuccess={onClose} commentBoxRef={commentBoxRef} {...rest} />}
		</Stack>
	);
};
